import styles from '../Confirmation.module.scss'
import { Card, Heading, Icon, Img } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'
import { routes } from 'utils/routes'
import ConfirmationWrapper from '../components/ConfirmationWrapper'
import { useTranslation } from 'next-i18next/pages'
import { useRouter } from 'next/router'
import classNames from 'classnames'

const CreditCheckView = () => {
  // i18n
  const { t } = useTranslation('registration', { keyPrefix: 'confirmation.creditCheck' })

  // Next router
  const { locale } = useRouter()

  return (
    <ConfirmationWrapper>
      <Card as="section" color="soft">
        <header className={styles['credit-check-header']}>
          <Icon name="hourglass" />
          <Heading as="h1" variant="h3">
            {t('checking.title')}
          </Heading>
        </header>

        <p className={styles.break}>{t('checking.description')}</p>

        <Link representation="button" href={routes(locale).home}>
          {t('checking.action')}
        </Link>
      </Card>

      <section className={styles['confirmation-card']}>
        <div className={styles.image}>
          <Img fill publicId="website/usps/local" alt="" />
        </div>

        <div className={classNames(styles.text, 'flex-col gap-400')}>
          <Heading as="h2" variant="h4" serif>
            {t('local.title')}
          </Heading>

          <p>{t('local.description')}</p>

          <Link representation="button" href={routes(locale).producers}>
            {t('local.action')}
          </Link>
        </div>
      </section>
    </ConfirmationWrapper>
  )
}

export default CreditCheckView
